/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function ChevronDownIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" {...props}>
            <path d="M8 9.98333C7.91111 9.98333 7.82511 9.96667 7.742 9.93333C7.65844 9.9 7.58889 9.85556 7.53333 9.8L4.46667 6.73333C4.34444 6.61111 4.28333 6.45556 4.28333 6.26667C4.28333 6.07778 4.34444 5.92222 4.46667 5.8C4.58889 5.67778 4.74444 5.61667 4.93333 5.61667C5.12222 5.61667 5.27778 5.67778 5.4 5.8L8 8.4L10.6 5.8C10.7222 5.67778 10.8778 5.61667 11.0667 5.61667C11.2556 5.61667 11.4111 5.67778 11.5333 5.8C11.6556 5.92222 11.7167 6.07778 11.7167 6.26667C11.7167 6.45556 11.6556 6.61111 11.5333 6.73333L8.46667 9.8C8.4 9.86667 8.32778 9.91378 8.25 9.94133C8.17222 9.96933 8.08889 9.98333 8 9.98333Z" />
        </svg>
    );
}
